import { AnsweringClient } from "../../clients/answeringClient";
import { describeApiError, isExpiredSession } from "../../utils/apiError";

export interface ReimburseLicenseModalControllerDelegate {
  didReimburseLicenses: () => void;
  didFailReimburseLicenses: (message: string) => void;
  applicationShouldLogout: () => void;
}

export class ReimburseLicenseModalController {
  constructor(
    private delegate: ReimburseLicenseModalControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) {}

  /**
   * Tenta executar o ressarcimento de licenças para uma aplicação.
   * * @param {string} accessToken O token de acesso do usuário.
   * @param {number} applicationId O ID da aplicação a ser ressarcida.
   */
  public async reimburseLicenses(
    accessToken: string,
    applicationId: number,
    hasRetried = false
  ): Promise<void> {
    try {
      await this.answeringClient.reimburseLicenses(accessToken, applicationId);
      this.delegate.didReimburseLicenses();
    } catch (error: any) {
      if (isExpiredSession(error) && !hasRetried) {
        const newTokens = await this.refreshTokens();
        if (!newTokens) {
          return;
        }
        return this.reimburseLicenses(
          newTokens.accessToken,
          applicationId,
          true
        );
      }
      this.delegate.didFailReimburseLicenses(
        describeApiError(
          error,
          "Não foi possível ressarcir as licenças. Tente novamente em instantes."
        )
      );
    }
  }

  private async refreshTokens(): Promise<{
    accessToken: string;
    refreshToken: string;
  } | void> {
    const refreshToken = localStorage.getItem("RefreshToken");
    if (!refreshToken) {
      this.delegate.applicationShouldLogout();
      return;
    }
    try {
      const response = await this.answeringClient.refreshToken(refreshToken);
      const tokens: { accessToken: string; refreshToken: string } =
        response.data;
      localStorage.setItem("AccessToken", tokens.accessToken);
      localStorage.setItem("RefreshToken", tokens.refreshToken);
      return tokens;
    } catch (error: any) {
      this.delegate.applicationShouldLogout();
      return;
    }
  }
}
